const MyRoutes = {
  CounterPage: '/counter',
  EmployeeListPage: '/employees',
}

export default MyRoutes;
